module.exports = "<div class=dtFolder-path__item> {{ $ctrl.folderPathPlaceholder }} <md-tooltip ng-if=$ctrl.folderPathFull class=\"dt-theme u-width-auto\"> {{ $ctrl.folderPathFull }} </md-tooltip> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/folder-path/folder-path.html
// module id = 8xGQ
// module chunks = 1